import Upload from './Upload'
import Uploaded from './Uploaded'

export {
    Upload,
    Uploaded
}
